//Steuerung zum Aufruf des Popup-Fensters zur Darstellung der Felgebezeichnung
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("custom-popup");
  const openLink = document.getElementById("open-popup-felge");
  const closeBtn = document.getElementById("close-popup");

  if (!popup || !closeBtn || !openLink) return;

  // Öffnen des Popups
  openLink.addEventListener("click", function (e) {
    console.log("geklickt!")
    e.preventDefault();
    popup.style.display = "flex";
  });

  // Schließen über das X
  closeBtn.addEventListener("click", function () {
    popup.style.display = "none";
  });

  // Schließen durch Klick außerhalb des Inhalts
  popup.addEventListener('click', function(e) {
    if (!e.target.closest('.popup-content')) {
      popup.style.display = 'none';
    }
  });

});
